import React, { useState } from "react"
import {
  Box, Link, Text, VStack,
} from "@chakra-ui/react"
import { annualDiscount, asMoney } from "utilities/strings"
import { createBillingPortalSession } from "api/accounts"
import Button from "components/Buttons/Button"
import Icon from "components/elements/Icon"
import { Plan } from "sharedTypes"

interface Props {
  currentPlan: Plan
  toInterval: "month" | "year"
}

const ChangeBillingInterval = ({ currentPlan, toInterval }: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    setIsLoading(true)
    try {
      const { data } = await createBillingPortalSession({
        flow: "subscription_update_confirm",
        stripePriceId: currentPlan.stripePriceIds[toInterval],
      })
      window.location.href = data.url
    } catch {
      setIsLoading(false)
      // Error message is displayed to the user automatically
    }
  }

  if (toInterval === "month") {
    return (
      <>
        <Icon icon="dot" size={1} ml={2} />
        <Link
          fontSize="xs"
          ml={2}
          onClick={!isLoading ? handleClick : undefined}
          color={isLoading ? "gray.600" : undefined}
          cursor={isLoading ? "default" : "pointer"}
          _hover={isLoading ? { textDecoration: "none" } : undefined}
        >
          {isLoading ? "Switching to Monthly Billing…" : "Switch to Monthly Billing"}
        </Link>
      </>
    )
  }

  return (
    <Box bgColor="gray.50" borderWidth={1} p={5} mt={8}>
      <VStack spacing={4}>
        <Text>
          <Text as="span" color="orange.400" fontWeight="semibold">Save {asMoney(annualDiscount("year", currentPlan), "USD", true)}</Text> by switching to annual billing and receiving a 40% discount.
        </Text>
        <Button variant="outline" onClick={handleClick} isLoading={isLoading}>Switch to Annual Billing</Button>
      </VStack>
    </Box>
  )
}

export default ChangeBillingInterval
